export default __webpack_public_path__ + "8eb139fc0cdf1531d7f6375993789ef6.svg";